import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { task, timeout } from 'ember-concurrency';
import { TrackedAsyncData } from 'ember-async-data';
import t from 'ember-intl/helpers/t';
import { on } from '@ember/modifier';
import perform from 'ember-concurrency/helpers/perform';
import set from 'ember-set-helper/helpers/set';
import InstructorManager from './instructor-manager';
import sortBy from '../../helpers/sort-by';
import UserNameInfo from '../user-name-info';
import UserStatus from '../user-status';
import BigSaveCancelButtons from '../big-save-cancel-buttons';

export default class InstructorGroupUsersComponent extends Component {
  @tracked usersBuffer = [];
  @tracked isManaging = false;

  @cached
  get usersData() {
    return new TrackedAsyncData(this.args.instructorGroup.users);
  }

  get users() {
    return this.usersData.isResolved ? this.usersData.value : [];
  }

  @action
  addUser(user) {
    this.usersBuffer = [...this.usersBuffer, user];
  }
  @action
  removeUser(user) {
    this.usersBuffer = this.usersBuffer.filter((obj) => obj !== user);
  }

  manage = task({ drop: true }, async () => {
    this.usersBuffer = await this.args.instructorGroup.users;
    this.isManaging = true;
  });

  save = task({ drop: true }, async () => {
    await timeout(10);
    this.args.instructorGroup.set('users', this.usersBuffer);
    await this.args.instructorGroup.save();
    this.isManaging = false;
  });
  <template>
    <section class="instructor-group-users" data-test-instructor-group-users ...attributes>
      <div class="instructor-group-users-header" data-test-header>
        <h2 class="title" data-test-title>
          {{#if this.isManaging}}
            {{t "general.instructorsManageTitle"}}
          {{else}}
            {{t "general.instructors"}}
            ({{@instructorGroup.users.length}})
          {{/if}}
        </h2>
        <div class="actions">
          {{#if this.isManaging}}
            <BigSaveCancelButtons @save={{this.save}} @cancel={{set this "isManaging" false}} />
          {{else if @canUpdate}}
            <button type="button" {{on "click" (perform this.manage)}} data-test-manage>
              {{t "general.instructorsManageTitle"}}
            </button>
          {{/if}}
        </div>
      </div>
      <div class="instructor-group-users-content">
        {{#if this.isManaging}}
          {{#unless this.manage.isRunning}}
            <InstructorManager
              @instructors={{this.usersBuffer}}
              @add={{this.addUser}}
              @remove={{this.removeUser}}
            />
          {{/unless}}
        {{else}}
          {{#if this.users.length}}
            <ul class="instructor-group-users-list" data-test-users-list>
              {{#each (sortBy "fullName" this.users) as |user|}}
                <li data-test-user>
                  <UserStatus @user={{user}} />
                  <UserNameInfo @user={{user}} />
                </li>
              {{/each}}
            </ul>
          {{/if}}
        {{/if}}
      </div>
    </section>
  </template>
}
